module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(!_vm.subscriptionComp) ? _c('div', [_c('div', {
    staticClass: "text-center hidden-xs"
  }, [(_vm.userRoleComp == 'Client') ? _c('h1', [_vm._v("Become a member")]) : _vm._e(), _vm._v(" "), (_vm.userRoleComp == 'Sitter') ? _c('h1', {
    staticStyle: {
      "color": "#926d9e"
    }
  }, [_vm._v("\n        Go Premium "), _c('i', {
    staticClass: "fa fa-paw",
    staticStyle: {
      "font-size": "32px"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.userRoleComp == 'Sitter') ? _c('p', {
    staticClass: "lead",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n        Get paid to cuddle with pets. Receive 5x more bookings.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.userRoleComp == 'Client') ? _c('p', {
    staticClass: "lead",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n        The best experience for cats and dogs.\n      ")]) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "hidden-sm hidden-md hidden-lg"
  }, [(_vm.userRoleComp == 'Client') ? _c('h1', {
    staticClass: "text-center"
  }, [_vm._v("\n        Become a member\n      ")]) : _vm._e(), _vm._v(" "), (_vm.userRoleComp == 'Sitter') ? _c('h1', {
    staticClass: "text-center",
    staticStyle: {
      "color": "#926d9e"
    }
  }, [_vm._v("\n        Go Premium "), _c('i', {
    staticClass: "fa fa-paw",
    staticStyle: {
      "font-size": "32px"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.userRoleComp == 'Sitter') ? _c('p', {
    staticClass: "lead",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n        Get paid to cuddle with pets. Receive 5x more bookings.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.userRoleComp == 'Client') ? _c('p', {
    staticClass: "lead",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n        The best experience for cats and dogs.\n      ")]) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "paypalModal",
      "data-backdrop": "static",
      "show": "true",
      "data-keyboard": "false",
      "role": "dialog",
      "aria-labelledby": "modalLabel",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content col-sm-offset-2 col-sm-8",
    staticStyle: {
      "padding": "0px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "overflow": "hidden",
      "margin-top": "0px"
    }
  }, [_c('div', {
    staticClass: "well",
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "0px"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "0px"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.selectedPlan.Description))]), _vm._v(" package\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', {
    staticClass: "h6"
  }, [_vm._v("\n                  Notice: we dont re-charge your card when the plan\n                  expires.")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "paypal-button-container"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.hidePaypalModal()
      }
    }
  }, [_vm._v("\n                Cancel\n              ")])])])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "plans"
  }, _vm._l((_vm.plansDto), function(plan) {
    return _c('div', {
      staticClass: "col-md-4 remove-margins-xs"
    }, [_c('div', {
      staticClass: "card-body"
    }, [(plan.DaysDuration == 365) ? _c('div', {
      staticClass: "ribbon"
    }, [_vm._v("Best Value")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "card-header"
    }, [_c('h4', {
      staticClass: "text-center font-weight-normal"
    }, [_vm._v("\n              " + _vm._s(plan.Description) + "\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "text-center"
    }, [_c('h1', {
      staticClass: "card-title pricing-card-title"
    }, [_vm._v("\n              $" + _vm._s(plan.Price) + " "), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v("/ mo")])]), _vm._v(" "), _c('ul', {
      staticClass: "list-unstyled"
    }, [(plan.PlanType == 2) ? _c('div', [_c('li', [_vm._v("Booking requests from to all")]), _vm._v(" "), _c('li', [_vm._v("More cuddles and more profit")]), _vm._v(" "), _c('li', [_vm._v("Priority over basic profiles")]), _vm._v(" "), _c('li', [_vm._v("Premium Account profile badge")])]) : _vm._e(), _vm._v(" "), (plan.PlanType == 1) ? _c('div', [_c('li', [_vm._v("Access to all pet sitters")]), _vm._v(" "), _c('li', [_vm._v("Unlimited booking requests")]), _vm._v(" "), _c('li', [_vm._v("Meet and greet amazing people")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "15px"
      }
    }, [_c('button', {
      staticClass: "btn btn-lg btn-info btn-block",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.showPaypalModal(plan)
        }
      }
    }, [_vm._v("\n                Upgrade Account\n              ")])])])])])
  })), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div')]) : _c('div', [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("You already have a valid subscription")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-md-offset-3",
    staticStyle: {
      "margin-top": "15px",
      "padding": "0px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success btn-block",
    on: {
      "click": function($event) {
        _vm.goHome()
      }
    }
  }, [_vm._v("\n        Go home\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h3', {
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "0px"
    }
  }, [_c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" Payment method\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "pendingModal",
      "data-backdrop": "static",
      "show": "true",
      "data-keyboard": "false",
      "role": "dialog",
      "aria-labelledby": "modalLabel",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content col-sm-offset-2 col-sm-8"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', {
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "0px"
    }
  }, [_c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" Payment Pending\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "overflow": "hidden",
      "margin-top": "0px"
    }
  }, [_c('div', {
    staticClass: "well",
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "0px"
    }
  }, [_c('div', [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("\n                  Pending Payment Completion, please wait...\n                ")])])]), _vm._v(" "), _c('br')])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center hidden-xs"
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n        Dupaws donates 10% of all subscriptions to feeding and helping stray\n        animals.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-sm hidden-md hidden-lg"
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "0px",
      "margin-left": "20px"
    }
  }, [_vm._v("\n        Dupaws donates 10% of all subscriptions to feeding and helping stray\n        animals.\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-45c9c2b6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Account/Subscribe.vue
// module id = 627
// module chunks = 2